import React from 'react';
import { Loader2 } from 'lucide-react';
import { CoinListItem } from '../../types';
import { useCurrency } from '../../context/CurrencyContext';

/**
 * Shared "Live: $X" indicator used by the Split Buy and Split Sell planners, so the
 * live-price reference looks identical everywhere. Renders nothing until a coin is
 * selected, a small spinner while fetching, the magnitude-aware price once loaded,
 * and nothing if the price is unavailable (graceful — never crashes). `fmt` applies
 * the selected display currency and magnitude-based decimals (e.g. XRP "$1.15").
 */
export function LivePriceLabel({
  selectedCoin,
  livePriceUsd,
  livePriceLoading,
}: {
  selectedCoin: CoinListItem | null;
  livePriceUsd: number | null;
  livePriceLoading: boolean;
}) {
  const { fmt } = useCurrency();
  if (!selectedCoin) return null;
  if (livePriceLoading) {
    return (
      <span className="flex items-center gap-1.5 text-xs text-slate-500">
        <Loader2 className="w-3 h-3 animate-spin" /> Fetching price…
      </span>
    );
  }
  if (livePriceUsd != null) {
    return (
      <span className="text-xs text-slate-500">
        Live: <span className="text-slate-300 font-mono">{fmt(livePriceUsd)}</span>
      </span>
    );
  }
  return null;
}
